var map = {
	"./AMR - One Health Consortium Logo.png": 8578,
	"./Afrihealth-logo-in-jpeg-2.jpg": 9292,
	"./Balikatang-Talassemia.jpg": 2280,
	"./DakshamA Health logo.png": 5841,
	"./Dialysis-support-group-PH.jpg": 2824,
	"./GreatLakes-Uganda.png": 9081,
	"./HFE_Blue and white logo png.png": 9680,
	"./Icanserve foundation-PH.png": 8908,
	"./Kidney-PH(KITAP).jpg": 1298,
	"./Kythe Foundation Inc-PH.png": 694,
	"./LADAFC.png": 2356,
	"./LOGO -JJK copy.jpg": 120,
	"./LOGO GHSVK.jpg": 7276,
	"./Logo FENAER.jpg": 6143,
	"./NOHIL-Lagos.jpg": 3171,
	"./National Blood bank-Ethiopia.jpg": 866,
	"./Neurofibromatosis-friends-PH.png": 2630,
	"./Obafemi Awolowo University-teaching-hospital.png": 5528,
	"./One Health at UCalgary Logo.png": 1342,
	"./PAPO-logo.jpeg": 597,
	"./PAWEM.jpg": 6005,
	"./PGH-cancer-survivors.png": 2267,
	"./PRAK-Kosovo.jpg": 965,
	"./PairLogo.png": 2265,
	"./Patient_Safety_Movement_logo_notag.png": 3681,
	"./Philippines-orphan-disorders.jpg": 2926,
	"./Powerful Patient Inc.-USA.png": 2762,
	"./Touched-by-max-PH.png": 272,
	"./University-Ilorin-Hospital.jpg": 9601,
	"./WFIPP-logo.png": 70,
	"./Women in Hepatitis Africa WIHA.jpg": 7766,
	"./bpkihs-logo.jpg": 5594,
	"./centre-for-initiaitve-and-development-cfid-taraba.jpg": 5854,
	"./logo sss.jpg": 8159,
	"./logo-grande-textCUIDAR.png": 2576,
	"./logoStudiorum[10y]transparentENG.png": 4539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9865;